import React from "react";
import { SpinnerLegacy } from "../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../components/modal/Dialog";
import { useOrder } from "../../../hooks/api/v2/order/useOrder";
import { ModifyOrderDialogForm } from "./ModifyOrderDialogForm";

type ModifyOrderDialogProps = {
  onDismiss: () => void;
  active: boolean;
  orderId: number;
};

export const ModifyOrderDialog = (props: ModifyOrderDialogProps) => {
  return (
    <Dialog active={props.active} onDismiss={props.onDismiss}>
      <ModifyOrderDialogContent {...props} />
    </Dialog>
  );
};

const ModifyOrderDialogContent = ({
  orderId,
  active,
  onDismiss,
}: ModifyOrderDialogProps) => {
  const orderQuery = useOrder(orderId);

  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Modify order"}
        description={
          "Disabled options can not be changed at the current order state."
        }
      />
      <DialogContent>
        {orderQuery.isLoading ? (
          <SpinnerLegacy />
        ) : (
          <>
            {active && orderQuery.data && (
              //need to render form when the dialog is displayed so the default values are set when the dialog is activated, rather than on inital render of the dialog
              <ModifyOrderDialogForm
                onDismiss={onDismiss}
                order={orderQuery.data}
              />
            )}
          </>
        )}
      </DialogContent>
    </>
  );
};
